import { render, staticRenderFns } from "./advertisingList.vue?vue&type=template&id=07f891a8&scoped=true&"
import script from "./advertisingList.vue?vue&type=script&lang=js&"
export * from "./advertisingList.vue?vue&type=script&lang=js&"
import style0 from "./advertisingList.vue?vue&type=style&index=0&id=07f891a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f891a8",
  null
  
)

export default component.exports